import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { HistoricoConciliacaoApiService } from './services/historico-conciliacao-api.service';
import { HistoricoConciliacao } from './models/historico-conciliacao';


@Injectable()
export class HistoricoConciliacaoResolver implements Resolve<HistoricoConciliacao> {

  constructor(
    private historicoConciliacaoApiService: HistoricoConciliacaoApiService,
  ) { }

  resolve(router: ActivatedRouteSnapshot): Observable<HistoricoConciliacao> {
    const contaId: number = router.params['contaId'];
    const historicoConciliacao: Observable<HistoricoConciliacao> = this.historicoConciliacaoApiService.getContasBanco(contaId);

    return zip(historicoConciliacao).pipe(
      map((values) => {
        return values[0];
      })
    );
  }
}